import React from "react";
import OnePanel from "./OnePanel";
import Styled, { LineBreak, Exhibit } from "./styles";
import styledComponents from 'styled-components';

const Name = styledComponents.span`
  color: #ff5252;
  font-weight: bold;
`;

const calculate1 = primeRates => {
  const USRates = primeRates.find(i => i.region === "US");

  return USRates ? (USRates.rate * 100).toFixed(2) : 0;
};
const calculate2 = debtClients => {
  const obj = debtClients.find(debtClient => debtClient.name === 'Prudent Bank');

  return obj ? obj.lt_debt_to_capital * 100 : '0';
}
const calculate3 = debtClients => {
  const obj = debtClients.find(debtClient => debtClient.name === 'Mezz Capital');

  return obj ? obj.lt_debt_to_capital * 100 : '0';
}
const calculate4 = constants => constants.initial_valuation / 1000000;
const calculate5 = constants => constants.wacc * 100;

const Investors = ({ primeRates, constants, activeRound, debtClients }) => (
  <OnePanel title="THE INVESTORS">
    Teresa and Anna were in charge of raising capital. As recent college graduates, they do not have any money
    to invest in their business. The five team members agreed that they would try their best to fund the business
    through debt capital because they want to retain control over their business. Also, they know that the value
    of the business at the beginning is at a rock bottom. Based on all the research they did, they expect this
    business to be successful and the value of the business to increase exponentially. They, therefore, want
    to make sure that they make every effort to raise funds through debt.
    <LineBreak />
    The team registered their business, GENZ, in the state of CA. Based on the articles of incorporation, GENZ
    has 10M shares authorized at a par value of $0.00001. GENZ will issue one million shares at $0.00001 initially
    to meet the statutory minimum capital requirement. This will leave the company with 1M shares outstanding,
    9M shares available to issue.
    <LineBreak />
    Teresa researched thousands of investors and lined up meetings with three investors that provide loans:
    Prudent Bank, Mezz Capital, and Great White Financials.
    <LineBreak count={3} />
    <Styled.GreyBold>Prudent Bank</Styled.GreyBold>
    Her first meeting was with James Tyghtmon of Prudent commercial bank. Like most commercial banks, Prudent
    earns income from customer deposits &amp; savings. They do so by investing the deposits in income earning
    assets that generate minimum returns to cover the cost of managing customer deposits and savings. Given that
    customers have the right to withdraw their deposits at any time, commercial banks have to be careful how they
    use those deposits for investments.
    <LineBreak />
    At first, Teresa and Anna were not sure if they should approach the small business banking division or the
    corporate banking division. They noticed that the corporate banking division has technology experts, so they
    decided to start with the corporate banking division. They set up a meeting with James Tyghtmon, director of
    technology lending and debt capital markets in Prudent Bank’s corporate banking division. After the initial
    introductions they dived right into business.
    <LineBreak />
    <Name>Teresa</Name>: "We’ve identified an opportunity to capture a significant market share in a fast growing technology
    sector , and we are seeking capital to pursue opportunity."
    <LineBreak />
    <Name>James</Name>: "That’s great! But do you understand the role commercial banks play in society?"
    <LineBreak />
    <Name>Teresa</Name>: "You save and lend money to individuals and organizations, like all commercial banks."
    <LineBreak />
    <Name>James</Name>: "We do more than that. We match savers and borrowers so that capital in our society, our community,
    is productive. We are the guardians of the economy’s financial system. Therefore, we don’t take many risks.
    We invest in assets that are low risk. You’re a startup. That’s inherently risky. How much equity did you raise?"
    <LineBreak />
    <Name>Teresa</Name>: "We weren’t interested in raising equity at this point. We didn’t want to give up any ownership."
    <LineBreak />
    <Name>James</Name>: "Teresa, there’s no way Prudent Bank would be able to provide a loan if you and your team have not
    raised any equity. Our debt policy states that we cannot lend money to anyone if they exceed our debt to
    capital limit requirement (See <Exhibit number={5} round={activeRound} />).
    In other words, we won’t lend to any company that has a debt to capital ratio higher than {calculate2(debtClients)}%. To determine our
    lending rates We use the prime rate as our base rate {calculate1(primeRates)}% and then we add a credit spread plus
    additional spread based on our terms &amp; conditions (See <Exhibit number={5} round={activeRound} />). Please reach out to Jermaine
    at Mezz Capital. He might be able to provide funding without equity."
    <LineBreak count={3} />
    <Styled.GreyBold>Mezz Capital</Styled.GreyBold>
    Teresa contacted Jermaine who was a workhorse. Jermaine started his career in Investment Banking within the TMT sector
    and moved up the ranks from Analyst to Director very quickly. He wanted more of a challenge, saw an opportunity in the
    subordinated debt space, and decided to start his own fund - Mezz Capital, a mezzanine fund that provides both debt and
    equity capital to companies. Mezzanine funds seek to invest in promising, but risky companies that could repay within a
    few years. They are usually subordinate to commercial lending debt and therefore these lenders expect to be compensated
    for the additional risks (i.e. charge a higher interest rate).
    <LineBreak />
    <Name>Teresa</Name>: "I hope you were able to review our business plan. What do you think about this opportunity?"
    <LineBreak />
    <Name>Jermaine</Name>: "I’ve reviewed your business plan and it. looks good, I’m interested in investing. I can’t invest in equity at
    this point, but I can offer debt. Mezz Capital offers better debt-to-capital requirement terms than Prudent Bank or any
    other commercial bank."
    <LineBreak />
    <Name>Teresa</Name>: "You mean your upper limit for the debt-to-capital ratio is higher than that of commercial banks?"
    <LineBreak />
    <Name>Jermaine</Name>: "That’s exactly correct. To be exact, our debt to capital ratio limit is {calculate3(debtClients)}%
    whereas Prudent Bank’s is {calculate2(debtClients)}%."
    <LineBreak />
    The fact that your company does not have equity capital is the obstacle that is preventing us from forming a partnership.
    You will still need to raise equity before we can lend. You should talk to David, an angel investor. Actually, please reach
    out to Greg Shark of Great White Financials as well. They like to take bigger risks.
    <LineBreak count={3} />
    <Styled.GreyBold>Great White Financials</Styled.GreyBold>
    <Name>Teresa</Name>: "Hi Mr. Shark, we need funding for a unique opportunity we would like to capture. Would you be able to help?"
    <LineBreak />
    <Name>Mr. Shark</Name>: "But of course! We are here for you and we provide generous funding amounts. More so than any other investors.
    We only ask that you pay us a small annual fee of ~15% of any funding we provide to you that remains outstanding."
    <LineBreak count={3} />
    <Styled.GreyBold>Angel Investors</Styled.GreyBold>
    Teresa then met with David Wong, an angel investor who runs a small syndicate out of a converted garage in Menlo Park. Angel investors
    write the earliest institutional-ish checks, funding companies at the pre-seed and seed stages when there's little more than a team,
    a plan, and a hope. They invest their own money, so their decisions are personal, and they often bet on people as much as on ideas.
    Each angel also has a personal cap on how much they can commit to any one company.
    <LineBreak />
    <Name>David</Name>: "Hey Teresa, I heard great things about you and your team. How can I help?"
    <LineBreak />
    <Name>Teresa</Name>: "Hi David, we have a unique opportunity that would generate immense returns for you and your firm."
    <LineBreak />
    <Name>David</Name>: "Tell me more!"
    <LineBreak />
    <Name>Teresa</Name>: "It’s the image sensor market. We are developing an image sensor technology that is at least 10x better
    than any other image sensor on the market. It’s a great fit for the automobile and mobile phone sectors. However,
    it will take some time to get the product to market."
    <LineBreak />
    <Name>David</Name>: "I’m still listening."
    <LineBreak />
    <Name>Teresa</Name>: "There’s an opportunity to offer existing technologies, which would allow us to enter the market now."
    <LineBreak />
    <Name>David</Name>: "But we invest in disruptive innovation, why would I want to invest in existing technologies? What are you offering?"
    <LineBreak />
    <Name>Teresa</Name>: "For you, low risks and high returns. For the market, servicing unmet demand. We are in a great position to capture value."
    <LineBreak />
    <Name>David</Name>: "There must be other competitors?"
    <LineBreak />
    <Name>Teresa</Name>: "All the major competitors are resource constrained. However, there are a few other startups that are likely to compete directly
    with us. It will be very competitive amongst these other startups, but we have a superior team with a track record of success. Here’s our
    business plan including our 1 year financial projections."
    <LineBreak />
    <Name>David</Name>: "Thanks Teresa! I will review with my team and we’ll be in touch."
    <LineBreak />
    Given that angels invest at the earliest stages with little track record, they place significant value in the strength of the team. David
    is no different. In fact, David prides himself on his ability to look into the soul of the founding team and see if they have what it takes.
    It’s a skill that he believes he learned from being a serial entrepreneur. He’s taken companies from seed stage to series stages to exits.
    He even allows founders that he invested in to buyback shares from him only after a year. This is very uncommon in angel investing, but
    reflects his maverick style approach to business.
    <LineBreak />
    A few weeks later, Teresa gets a call from David.
    <LineBreak />
    <Name>David</Name>: "The business plan looks solid! And nice work on the financial projections! We want to invest in you and your team. We ran some analyses
    and determined that an appropriate value for your business is ${calculate4(constants)}M based on several factors including your strengths (strong team and partnership
    agreements) and weaknesses (you are a startup). We will evaluate your business periodically and adjust your company’s value to current market rates.
    Here’s our valuation approach for each year (<Exhibit number={6} round={activeRound} />). Overall, we expect an annual return of at least{" "}
    {calculate5(constants)}% from this opportunity, assuming you are holding no debt. I’m sending over the term sheet for you to review and sign. We
    look forward to partnering with you on this exciting journey!"
    <LineBreak count={3} />
    <Styled.GreyBold>Venture Capital</Styled.GreyBold>
    If angels are the first spark, venture capital is the accelerant. VC firms pool money from institutional LPs (endowments, pensions,
    family offices) and deploy it into companies that already have a product and real market results behind them. In the real world, some
    VCs do write checks on day one at the seed stage, but the larger growth-stage funds almost always want to see a full year of actual
    performance before they commit. They're paying to reduce risk, and one year of execution is the cheapest risk they can buy. That's why
    in this exercise Redwood won't fund you in Year 1: they want to see how the team executes against its plan before betting bigger.
    Once you have that Year 1 track record, VC checks are larger than an angel's, but so is the ownership they take. VCs also have a
    fund-mandated ceiling on how much of the fund they can put into any single company, so no matter how much they love a deal, there's a
    hard cap.
    <LineBreak />
    Teresa's next meeting was with Priya Kapoor, a partner at Redwood Ventures. Priya is famous in the Valley for writing initial term sheets
    on the back of restaurant napkins and mailing the original napkin to founders as a keepsake when a deal closes. Three napkins hang in
    frames behind her desk, the ones that turned into unicorns.
    <LineBreak />
    <Name>Priya</Name>: "Teresa, I've read the deck. I want to hear the one sentence that makes me regret not investing."
    <LineBreak />
    <Name>Teresa</Name>: "One product, two segments, no direct competitor."
    <LineBreak />
    <Name>Priya</Name>: "Good pitch. Now go ship a full year. Bring me Year 1's actuals against your projections. If the model holds up,
    Redwood will lead your Year 2 round."
    <LineBreak />
    A year later, Teresa returns with Year 1 results in hand. The numbers back up the pitch, and Priya delivers a term sheet (on Cafe Vino
    letterhead this time; the napkins are ceremonial). Redwood Ventures is in, though at a valuation that requires Teresa to share more
    ownership than she did with the angel round.
    <LineBreak count={3} />
    <Styled.GreyBold>Private Equity Investor</Styled.GreyBold>
    Private equity sits at the opposite end of the timeline from angels. PE firms invest in more mature companies with proven cash flows and
    a real operating history. In practice, that usually means at least five years of audited financials. Their playbook is different too:
    instead of betting on a story, they look for operational levers to pull, such as cost restructuring, margin improvement, or acquisitions
    of adjacent businesses. PE checks are typically the largest of the three equity categories, but each firm still has a capital ceiling per
    company.
    <LineBreak />
    Because PE needs a track record, GENZ won’t be a fit until at least Year 3, when the team has two full years of audited financials to
    point to. That’s shorter than the five years many PE firms prefer, but a few funds (especially special-situations shops) will look at
    companies with as little as two years of demonstrated performance when the operating metrics are strong and the market opportunity is
    unusually large.
    <LineBreak />
    Teresa nevertheless took an introductory meeting with Roland Fairchild, managing director at Sterling Capital Partners. Roland is the
    type of investor a founder meets over a two-hour dinner at a members-only club. He has never once said the word "startup" in his career,
    refers to companies exclusively by their EBITDA multiple, and loosens his tie by exactly one inch after 6 PM as his sole concession to
    informality. His parting words to Teresa: "Come back when you’ve printed two years of audited financials."
  </OnePanel>
);

export default Investors;



// WEBPACK FOOTER //
// ./src/components/bcase/Investors.js